import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';

import { withStyles } from '@material-ui/core/styles';

import { editVendorForm } from '../../../store/actions';

const styles = theme => ({
  card: {
    marginTop: theme.spacing.unit*3,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  marginRight: {
    marginRight: theme.spacing.unit*2,
  },
  marginLeft: {
    marginLeft: theme.spacing.unit*2,
  },
});

const VendorForm = ({ classes, vendor, editVendorForm }) => {
  const { validation } = vendor;

  return (
    <Card className={classes.card}>
      <CardContent className={classes.content}>
        <div>
          <TextField
            error={!!validation.validateField("name")}
            helperText={validation.validateField("name")}
            className={classes.marginRight}
            label="Name"
            margin="none"
            value={vendor && vendor.name}
            onChange={(event) => editVendorForm({name: event.target.value})}
          />
        </div>
      </CardContent>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  vendor: state.formData.vendor,
});

const mapDispatchToProps = {
  editVendorForm,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(VendorForm);



// WEBPACK FOOTER //
// ./src/components/admin/Vendors/VendorForm.jsx